import restful from '../vuex'

const state = {
  ...restful.states('users_shop')
}

const getters = {
  ...restful.getters('users_shop')
}

const actions = {
  ...restful.actions('users_shops')
}

const mutations = {
  ...restful.mutations('users_shop')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
